import { useQuery } from "@tanstack/react-query"

import { client } from "@/api"
import queryKeys from "@/api/queryKeys"
// import { AttractionType } from "@/common/types"

function useListAttractionTypes() {
  return useQuery({
    queryKey: queryKeys.attractions.listTypes({}).queryKey,
    queryFn: () =>
      client.get(`/attractions/types`).then((response) => response.data),
  })
}
export default useListAttractionTypes
